$( document ).on( 'ready', function() {
	$( '.navbar-toggler' ).click( function() {
		var $element = $( this ).data( 'target' );
		$($element).toggleClass( 'show' );
	} );
} );